import { PlusOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { message, Upload, UploadProps } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { base64Mime } from 'magic-types';
import { useState } from 'react';
import { toBase64 } from 'utils/getImage';
import { v4 } from 'uuid';

type Document = Pick<Todo.ErpOrder, 'documentFile' | 'documentType' | 'documentName'>;

function DocumentUpload({
  document,
  onUpload,
  ...otherProps
}: {
  document?: Document;
  onUpload: (document?: Document) => void;
} & UploadProps) {
  const { t } = useTranslate();

  const [file, setFile] = useState<UploadFile | undefined>(() => {
    if (!document) {
      return undefined;
    }
    try {
      const mime = base64Mime(document.documentFile);
      return {
        name: document.documentName,
        fileName: document.documentName,
        url: mime ? `data:${mime};base64,${document.documentFile}` : document.documentFile,
        uid: v4(),
        type: mime,
      };
    } catch (_) {
      return undefined;
    }
  });

  return (
    <Upload
      listType="picture-card"
      fileList={file ? [file] : []}
      onChange={({ fileList: [file] = [] }) => {
        if (!file) {
          setFile(undefined);
          onUpload(undefined);
        } else if (file.status === 'error' || file.status === 'removed') {
          setFile(undefined);
          onUpload(undefined);
        } else {
          setFile(file);
        }
      }}
      customRequest={({ onSuccess, onError, onProgress, file: _file }) => {
        onProgress?.({ percent: 20 } as any);
        const file = _file as File;
        return toBase64(new Blob([file], { type: file.type }))
          .then((url) => {
            onProgress?.({ percent: 100 } as any);
            onSuccess?.({ data: { url } });
            onUpload({
              documentFile: url,
              documentType: file.type,
              documentName: file.name,
            });
          })
          .catch((err) => {
            onError?.(err);
            message.error(t('trade.上传失败'));
          });
      }}
      showUploadList={{
        showPreviewIcon: false,
      }}
      {...otherProps}
    >
      {file ? null : (
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>{t('上传附件')}</div>
        </div>
      )}
    </Upload>
  );
}

export default DocumentUpload;
